(function ($, App, Utils, Components) {
    'use strict';

    const logger = new Logger('Privacy');

    Components.create('Privacy', {

        Selectors: {
			toBeHidden: '.to-be-hidden',
            mktFlagOn: 'input:radio[name=privacyMarketing]:first',
			mktFlagOff: 'input:radio[name=privacyMarketing]:last',
			contactTypeSelectWrapper: '.contact-type-select-wrapper',
			contactTypeInputWrapper: '.contact-type-input-wrapper'
        },

		manageMktFlagActivation: (mktFlagOn) => {
			mktFlagOn.change(() => {
				$(Components.Privacy.Selectors.contactTypeSelectWrapper).removeClass('hide'); 
				$(Components.Privacy.Selectors.contactTypeInputWrapper).addClass('hide');
			})
		},
		
		manageMktFlagDeactivation: (mktFlagOff) => {
			mktFlagOff.change(() => {
				$(Components.Privacy.Selectors.contactTypeInputWrapper).removeClass('hide');
				$(Components.Privacy.Selectors.contactTypeSelectWrapper).addClass('hide');
			})
		},

        init: () => {
			$(Components.Privacy.Selectors.toBeHidden).addClass('hide');
			let $mktFlagOn = $(Components.Privacy.Selectors.mktFlagOn);
			let $mktFlagOff = $(Components.Privacy.Selectors.mktFlagOff);
            if ($mktFlagOn.length && $mktFlagOff.length) {
				Components.Privacy.manageMktFlagActivation($mktFlagOn);
				Components.Privacy.manageMktFlagDeactivation($mktFlagOff);
            }
        }

    });

})(jQuery,
    window.App,
    window.App.Utils,
    window.App.Components
);
